import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed top-4 left-4 right-4 sm:left-auto z-[100] flex flex-col gap-3 sm:max-w-sm sm:w-full pointer-events-none">
      @for (t of toast.toasts(); track t.id) {
        <div
          class="pointer-events-auto rounded-xl shadow-lg border bg-white p-4 flex gap-3 items-start animate-[slideIn_0.2s_ease-out]"
          [class.border-green-200]="t.kind === 'success'"
          [class.border-red-200]="t.kind === 'error'"
          [class.border-amber-200]="t.kind === 'warning'"
          [class.border-blue-200]="t.kind === 'info'"
          role="status"
          aria-live="polite">
          <div class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
               [class.bg-green-50]="t.kind === 'success'"
               [class.bg-red-50]="t.kind === 'error'"
               [class.bg-amber-50]="t.kind === 'warning'"
               [class.bg-blue-50]="t.kind === 'info'">
            @switch (t.kind) {
              @case ('success') {
                <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
              }
              @case ('error') {
                <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              }
              @case ('warning') {
                <svg class="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M5.07 19h13.86c1.54 0 2.5-1.67 1.73-3L13.73 4a2 2 0 00-3.46 0L3.34 16c-.77 1.33.19 3 1.73 3z"/>
                </svg>
              }
              @default {
                <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              }
            }
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-sm font-semibold text-gray-900">{{ t.title }}</p>
            @if (t.message) {
              <p class="text-xs text-gray-600 mt-0.5 break-words">{{ t.message }}</p>
            }
          </div>
          <button (click)="toast.dismiss(t.id)"
                  class="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
                  aria-label="Dismiss notification">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
      }
    </div>
  `,
  styles: [`
    @keyframes slideIn {
      from { transform: translateX(20px); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
  `]
})
export class ToastContainerComponent {
  toast = inject(ToastService);
}
